//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const TABLE_LIST_COLUMNS = [
  {
    name: "id",
    required: true,
    label: "#ID",
    align: "right",
    field: (row) => row.id,
    sortable: false,
  },
  {
    name: "email",
    align: "left",
    label: "E-mail",
    field: (row) => row.email,
    sortable: false,
  },
  {
    name: "name",
    label: "Nome de Utilizador",
    align: "left",
    field: (row) => row.name,
    sortable: false,
  },
  {
    name: "department",
    label: "Departamento",
    align: "left",
    field: (row) => row.department,
    sortable: false,
  },
  {
    name: "type",
    label: "Tipo de Utilizador",
    align: "left",
    field: (row) => row.role.replaceAll("_", " "),
    sortable: false,
  },
  //TODO Adcionar icon verde ou vermelho para utilizadores ativos e inativos
  {
    name: "status",
    label: "Estado",
    align: "left",
    field: (row) => row.state,
    icon: {
      conditional: true,
      false: {
        name: "mdi-account-off",
        label: "Inativo",
        color: "red-4",
      },
      true: {
        name: "mdi-account",
        label: "Ativo",
        color: "green-4",
      },
      locked: {
        name: "mdi-lock",
        label: "Bloqueado",
        color: "red-4",
      },
    },
    sortable: false,
  },
  {
    name: "current_sign_in_ip",
    label: "IP de Login",
    align: "left",
    field: (row) => row.current_sign_in_ip,
    sortable: false,
  },
  {
    name: "sign_in_count",
    label: "Índice de Actividade",
    align: "left",
    field: (row) => row.sign_in_count,
    sortable: false,
  },
  {
    name: "last_sign_in_at",
    label: "Ultimo Login",
    align: "left",
    field: (row) => row.last_sign_in_at,
    sortable: false,
  },
  // {
  //   name: "confirmed_at",
  //   label: "Confirmado em",
  //   align: "left",
  //   field: (row) => row.confirmed_at,
  //   sortable: false,
  // },
  {
    name: "failed_attempts",
    label: "Tentativas falhadas",
    align: "left",
    field: (row) => row.failed_attempts,
    sortable: false,
  },
  {
    name: "locked_at",
    label: "Bloqueado em",
    align: "left",
    field: (row) => row.locked_at,
    sortable: false,
  },
];

export default {
  name: "UserManagementTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: () => { },
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 10, // current rows per page being displayed
    },
    columns: TABLE_LIST_COLUMNS,
  }),
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
    statusColumn(state) {
      return state;
    },
  },
};
